module.exports = __webpack_public_path__ + "static/media/มะโรง.192ea440.png";